import { createActionGroup, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { IServerSideGetRowsRequest } from 'ag-grid-community/dist/types/src/interfaces/iServerSideDatasource';
import { ResidentCallReasons } from '../../../../../../graphql';

export const RESIDENT_CALL_REASON_API_ACTIONS = createActionGroup({
  source: 'Resident Call Reason SSR API',
  events: {
    get: props<{ request: IServerSideGetRowsRequest }>(),
    success: props<{ rows: ResidentCallReasons[]; totalCount: number }>(),
    error: props<{ error: HttpErrorResponse }>(),
  },
});

export const RESIDENT_CALL_REASON_ACTIONS = createActionGroup({
  source: 'Resident Call Reason Report',
  events: {
    setActiveView: props<{ viewName: string | null }>(),
  },
});
